import { Portal } from '@headlessui/react';
import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { AnimatePresence, motion } from 'motion/react';
import { FC } from 'react';
import Badge from '../../Badge/Badge';
import Button from '../../Button/Button';

export type TProps = {
  isOpen: boolean;
  onClose?: () => void;
  numberOfSelectedItems?: number;
  actions: {
    label: string;
    onClick: () => void;
    icon: TIconName;
  }[];
};

const StaticGlobalActionBar: FC<TProps> = (props) => {
  const { isOpen, onClose, numberOfSelectedItems, actions } = props;

  return (
    <Portal>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed left-0 right-0 bottom-0 z-static-global-action-bar flex items-center justify-center p-4"
            initial={{
              opacity: 0,
              y: '100%',
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              y: '100%',
            }}
          >
            <div className="typography:prose bg-black rounded-full py-3 px-4 text-white flex items-center gap-4 min-w-0 md:min-w-96">
              {numberOfSelectedItems && (
                <div className="flex items-center gap-2">
                  <Badge size="sm" variant="solid" colour="green">
                    {numberOfSelectedItems}
                  </Badge>

                  <p>Selected</p>
                </div>
              )}

              <div className="flex items-center gap-4 ml-auto">
                {actions.map((action, id) => (
                  <>
                    <Button
                      key={id}
                      variant="link-inline"
                      linkColour="white"
                      onClick={action.onClick}
                    >
                      <UntitledIcon
                        className="w-4 h-4 shrink-0"
                        name={action.icon}
                      />{' '}
                      {action.label}
                    </Button>

                    <div
                      className="bg-white w-px h-4 last:hidden"
                      aria-hidden={true}
                    />
                  </>
                ))}
              </div>

              <Button
                onClick={onClose}
                size="xs"
                variant="ghost"
                colour="white"
              >
                <UntitledIcon className="w-3 h-3 shrink-0" name="x-close" />
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Portal>
  );
};

export default StaticGlobalActionBar;
